import type { RoleCode } from '@/consts/roles';
import { env } from '@/env/env';

import type { User } from './schema';

export const hasAnyRole = (user: User | null | undefined, roles: RoleCode[]): boolean => {
  if (env.VITE_BYPASS_PERMISSIONS === 'true') return true;
  if (!user?.Roles) return false;
  return user.Roles.some((role) => roles.includes(role.Id as RoleCode));
};

export const hasPermission = (user: User | null | undefined, permission: string): boolean => {
  if (env.VITE_BYPASS_PERMISSIONS === 'true') return true;
  if (!user?.Permissions) return false;
  return user.Permissions.some((p) => p.toLowerCase() === permission.toLowerCase());
};

export const hasAllPermissions = (user: User | null | undefined, permissions: string[]): boolean => {
  if (env.VITE_BYPASS_PERMISSIONS === 'true') return true;
  if (!user?.Permissions) return false;
  if (permissions.length === 0) return true;
  const userPermsLower = new Set(user.Permissions.map((p) => p.toLowerCase()));
  return permissions.every((p) => userPermsLower.has(p.toLowerCase()));
};

export const hasAnyPermission = (user: User | null | undefined, permissions: string[]): boolean => {
  if (env.VITE_BYPASS_PERMISSIONS === 'true') return true;
  if (!user?.Permissions) return false;
  if (permissions.length === 0) return false;
  const userPermsLower = new Set(user.Permissions.map((p) => p.toLowerCase()));
  return permissions.some((p) => userPermsLower.has(p.toLowerCase()));
};
